import { render, staticRenderFns } from "./DashboardMainPanel.vue?vue&type=template&id=7b84adea"
import script from "./DashboardMainPanel.vue?vue&type=script&lang=ts"
export * from "./DashboardMainPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports